/** "Overwrite all to  ○ Off  ○ On" — the vendor's on/off bulk control. */
import { RadioGroup, RadioGroupItem } from '@vnetwork/ui/primitives';
import styles from './WafBulkConfigure.module.css';

export function OnOff({ value, onChange }: { value: boolean; onChange: (v: boolean) => void }) {
  return (
    <RadioGroup
      value={value ? 'on' : 'off'}
      onValueChange={(v) => onChange(v === 'on')}
      style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 'var(--vn-space-4)' }}
    >
      <span style={{ color: 'var(--vn-fg-muted)', fontSize: 'var(--vn-font-size-sm)' }}>Overwrite all to</span>
      <label className={styles.row} style={{ gap: 6, cursor: 'pointer' }}>
        <RadioGroupItem value="off" /> Off
      </label>
      <label className={styles.row} style={{ gap: 6, cursor: 'pointer' }}>
        <RadioGroupItem value="on" /> On
      </label>
    </RadioGroup>
  );
}

export default OnOff;
